import React from 'react'

import { reasons } from '.'

import Header from 'components/Text/Header'
import {
  FeedbackContainer,
  CrossButton,
  SubHeader,
  HorizontalSeparator,
  SubmitButton,
  TextArea,
  TextRadioForm
} from './Feedback.styles'

interface FeedbackProps {
  onClose: () => any
  onSubmit: () => any
}

class Feedback extends React.Component<FeedbackProps> {
  state: {
    selected: any
    answer: string
  } = {
    selected: null,
    answer: ''
  }

  setAnswer = (item: any) => {
    if (item.id !== 4) {
      this.setState({ answer: '' })
    }
    this.setState({ selected: item })
  }

  render() {
    return (
      <FeedbackContainer>
        <Header>Provide Feedback</Header>
        <CrossButton onClick={this.props.onClose} />
        <SubHeader>
          Please tell us why you decided to remove your job post.
        </SubHeader>
        <HorizontalSeparator />
        <p className={'reason'}>Reason for removing your post?</p>
        <TextRadioForm
          items={reasons}
          selected={this.state.selected}
          onSelected={this.setAnswer}
        />
        <TextArea
          placeholder={'Type at least 5 characters'}
          title='Provide Additional Feedback'
          disabled={this.state.selected?.id !== 4}
          value={this.state.answer}
          onChange={(e): any => {
            this.setState({ answer: e.target.value })
          }}
        />
        <SubmitButton
          disabled={
            !!this.state.selected
              ? false
              : true
          }
          onClick={this.props.onSubmit}
        >
          Submit
        </SubmitButton>
      </FeedbackContainer>
    )
  }
}

export default Feedback
